import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import SectionContent from './SectionContent'

import Styles from './styles.scss'


export default function DetailSection({ content, header }) {
  return (
    <div className="DetailSection">
      <div className={ Styles.header }>
        <FormattedMessage
          { ...header }
        />
      </div>

      <div className={ Styles.content }>
        <SectionContent
          content={ content }
        />
      </div>
    </div>
  )
}

DetailSection.propTypes = {
  header: PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,

  content: SectionContent.propTypes.content,
}
